import React from 'react';

import { FormField, FormHelp, Heading, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../models/index';
import YesAndNo from '../../../Widgets/YesAndNo';
import { MORE_RULES } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function MoreRules({ setSectionValues, section }: Props): JSX.Element {
  function onNoRules(): void {
    setSectionValues({
      [MORE_RULES.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesRules(): void {
    setSectionValues({
      [MORE_RULES.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <Heading level={3} css={{ textStyle: 'body-lg-bold', marginBottom: 'layout.tight' }}>
        Additional rules
      </Heading>
      <FormField
        required
        label={<Label>Want to add more rules to your lease?</Label>}
        control={
          <YesAndNo
            yesHandler={onYesRules}
            noHandler={onNoRules}
            yesActive={section.getFieldValue(MORE_RULES.FIELD_NAME.IS_ENABLED)}
          />
        }
        description={
          <FormHelp>
            You can customize your lease by selecting rules for property usage, resident activities, and the keys. You
            can also add your own rules.
          </FormHelp>
        }
      />
    </>
  );
}
